jQuery(function($) {

    $('#user-add-documents').on('submit', function(e){
        e.preventDefault();
        
        let $form = $(this),
            datas = new FormData($form[0]);

        $.ajax({
            url: $form.attr('action'),
            type: 'POST',
            data: datas,
            processData: false,
            contentType: false,
            beforeSend: function(){
                $form.find('input[type="submit"]').attr('disabled', true)
                $form.find('.alert').remove();
            },
            success: function(response) {
                $form.find('input[type="submit"]').attr('disabled', false);
                $form.prepend(`<p class="alert alert-${response.success ? 'success' : 'danger'}">${response.data}</p>`);
                $form[0].reset();
            }
        });
    });

    $('a.user_remove_document').on('click', function(e){
        e.preventDefault();

        let $this = $(this);

        var r = confirm("Supprimer le document ?");

        if(r == true) {

            $.ajax({
                url: kreenoot_child.ajax_url,
                type: 'POST',
                data: {
                    action: 'user_remove_document',
                    row_index: $this.attr('data-rowindex'),
                },
                beforeSend: function(){
                    $this.addClass('disabled')
                },
                success: function(response) {
                    window.location.reload();
                }
            });
        }

    });

});